import { FileHeader } from "./FileHeader";
import {
  Alert,
  CircularProgress,
  LinearProgress,
  Snackbar,
} from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// import { Document, Page } from "react-pdf/dist/esm/entry.webpack5";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import PDFModalSignature from "./PDFModalSignature";
import interact from "interactjs";
import RejectModal from "./RejectModal";
import ApiServices, { _URL_ASSETS } from "../../services";
import PDFModalStamp from "./PDFModalStamp";
import { useNavigate, useParams } from "react-router-dom";
import AppContext from "../../contexts/appContext";
import { v4 as uuid } from "uuid";
import {
  AUTH_STATE_DONE,
  AUTH_STATE_UPDATE,
  AUTH_TOKEN,
  USER_DATA,
  SET_PROFILE,
  STATE_DONE,
} from "../../constants";
import handleError from "../../services/handleError";
import AppearanceModal from "./AppearanceModal";
import SignatureToolbar from "../../components/SignatureToolbar";
import Utils from "../../services/utils";
import moment from "moment";
import Moment from "react-moment";

// documents/{unique}/{token}
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

const PDFApproval = () => {
  const { t } = useTranslation("translation");
  const {
    state: { auth },
    dispatch,
  } = useContext(AppContext);

  const returnURL = new URLSearchParams(document.location.search).get(
    "returnUrl"
  );
  const options = {
    cMapUrl: "cmaps/",
    cMapPacked: true,
    standardFontDataUrl: "standard_fonts/",
  };

  const [file, setFile] = useState("");
  const [fileTitle, setFileTitle] = useState("");
  const [canSign, setCanSign] = useState(false);
  const [canDownload, setCanDownload] = useState(false);
  const [canNotSignNote, setCanNotSignNote] = useState(false);
  const [PDFCurrentPage, setPDFCurrentPage] = useState(1);
  const [PDFNumPages, setPDFNumPages] = useState(1);
  const [progress, setProgress] = useState(0);
  const [signatureImages, setSignatureImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageChanged, setselectedImageChanged] = useState(false);
  const [activeSignature, setActiveSignature] = useState(null);
  const [activeStamp, setActiveStamp] = useState(null);
  const [stampImages, setStampImages] = useState([]);
  const [selectedStamp, setSelectedStamp] = useState(null);
  const [selectedStampChanged, setselectedStampChanged] = useState(false);
  const [visibleSignatureModal, setVisibleSignatureModal] = useState(false);
  const [visibleStampModal, setVisibleStampModal] = useState(false);
  const [visibleRejectModal, setVisibleRejectModal] = useState(false);
  const [visibleGlobalAppearanceModal, setVisibleGlobalAppearanceModal] = useState(false);
  const [visibleAppearanceModal, setVisibleAppearanceModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [signComment, setSignComment] = useState("");
  const [docTransform, setDocTransform] = useState("translateY(0) scale(1)");
  const [isMultiPage, setIsMultiPage] = useState(false);
  const [signOptions, setSignOptions] = useState({
    displayOnBottom : false ,
    showName : false ,
    jobtitle : false ,
    showDate : false ,
    showReason: false     
  });
  const docRef = useRef();
  const signatureRef = useRef();
  const headRef = useRef();
  const { unique, token } = useParams();
  const [signatureImageUrl, setSignatureImageUrl] = useState("");
  const [saveSignatureLoading, setSaveSignatureLoading] = useState(false);

  // New state for approval signing
  const [isApprovalSigning, setIsApprovalSigning] = useState(false);
  const [approvalData, setApprovalData] = useState(null);
  const [approvalSignatureFields, setApprovalSignatureFields] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [fileDataResponse, setFileDataResponse] = useState(null);
  const [navigationFields, setNavigationFields] = useState([]);
  const [originalFields, setOriginalFields] = useState([]);
  const [hasInitializedApproval, setHasInitializedApproval] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
      if (!auth.token) {
        return;
      }
      getProfileData();
      getFileData();
    return () => {};
  }, []);

  // Separate effect to check approval signing after currentUser is loaded (only once)
  useEffect(() => {
      if (currentUser && unique && token && fileDataResponse && !hasInitializedApproval) {
        checkIfApprovalSigning();
        setHasInitializedApproval(true);
      }
  }, [currentUser, unique, token, fileDataResponse, hasInitializedApproval]);
  const UI_OF_DELETE = ()=>{
    if (document.querySelector('.signature_images')) {
      // if (Utils.is_touch_enabled()) {
      //   document.querySelector('.signature_images').addEventListener('touchstart', (e)=>{
      //     document.querySelectorAll('.signature-resize-drag').forEach((el) => {
      //       if (!el.contains(e.target)) {
      //         // remove active signature
      //         setActiveSignature(null);
      //       }else{
      //         // do no thing
      //       }
      //     })
      //     document.querySelectorAll('.stamp-resize-drag').forEach((el) => {
      //       if (!el.contains(e.target)) {
      //         // remove active stamp
      //         setActiveStamp(null);
      //       }else{
      //         // do no thing
      //       }
      //     })
      //   },true)
      // }else{
        document.querySelector('.signature_images').addEventListener('mousedown', (e)=>{
          document.querySelectorAll('.signature-resize-drag').forEach((el) => {
            if (!el.contains(e.target)) {
              // remove active signature
              setActiveSignature(null);
            }else{
              // do no thing
            }
          })
          document.querySelectorAll('.stamp-resize-drag').forEach((el) => {
            if (!el.contains(e.target)) {
              // remove active stamp
              setActiveStamp(null);
            }else{
              // do no thing
            }
          })
        },true)
      // }
    }
  }
  const getFileData = () => {
    ApiServices.getData({ usrToken: auth.token }, urlParams())
      .then((res) => {
        setFileDataResponse(res);
        dispatch({ type: AUTH_STATE_DONE });
        if (res.success === true) {
          setFile(res.payload.document);
          setFileTitle(!!res.payload.filename? res.payload.filename:res.payload.title);
          setCanSign(res.payload.can_sign);
          setCanDownload(res.payload.can_download);
          setCanNotSignNote(res.payload.note);
        } else {
            handleError(res.code, dispatch);
        }
        if (res.code === 403 && res.status === "expire") {
          setIsExpired(true);
        }
      })
      .catch((err) => {
        console.log("Error: ", err); 
      });
  };
  const urlParams = () => {
    return {
      unique: unique,
      token: token,
    };
  };
  const getProfileData = () => {
    ApiServices.getProfileData({ token: auth.token })
      .then((res) => {
        if (res.success === true) {
          dispatch({
            type: SET_PROFILE,
            payload: {
              name: res.payload.name,
              email: res.payload.email,
              signatures: res.payload.signatures,
              options: res.payload.options,
              title: res.payload.title
            },
          });
          setSignOptions(res.payload.options)
          setCurrentUser(res.payload);
        } else {
          handleError(res.code, dispatch);
        }
      })
      .catch((err) => {
        console.error("===> Error response : ", err);
      });
  };

  const checkIfApprovalSigning = async () => {
    try {
      // Only proceed if we have the file data response
      if (!fileDataResponse || !fileDataResponse.success) {
        return;
      }
      
      const response = fileDataResponse.payload;
      
      // Always set navigation fields if there are any fields in the response
      // This allows users to see page navigation (signature pages) even when they can't sign
      if (response.fields && response.fields.length > 0) {
        const fields = response.fields.map(field => ({
          ...field,
          page: Number(field.page),
          width: Number(field.width),
          height: Number(field.height),
          x: Number(field.x),
          y: Number(field.y),
          sign_status: field.sign_status !== undefined ? Number(field.sign_status) : 0
        }));
        
        // Filter fields by sign_status: only show placeholders for fields with sign_status === 0 (not signed)
        // Keep all fields for navigation purposes
        const unsignedFields = fields.filter(field => field.sign_status === 0);
        setApprovalSignatureFields(unsignedFields);
        
        // Set navigation fields with all fields (for page navigation and indicators)
        setNavigationFields(fields);
        
        // Only set approval signing mode if user can actually sign
        if (response.can_sign) {
          setIsApprovalSigning(true);
          setApprovalData({
            title: response.title || "Approval",
            document: response.document,
            assignee: [{
              name: currentUser.name,
              email: currentUser.email,
              fields: response.fields
            }]
          });
        } else {
          // User cannot sign but can review
          setIsApprovalSigning(false);
        }
      } else {
        // No signature fields defined
        setApprovalSignatureFields([]);
        setIsApprovalSigning(false);
      }
    } catch (err) {
      console.error("Failed to check approval signing:", err);
    }
  };
  const onDocumentLoadSuccess = ({ numPages }) => {
    setPDFNumPages(numPages);
  };
  
  // Smart signing: check for default signature and auto-place or show modal
  const handleApprovalSignClick = async () => {
    const signatures = auth?.userData?.signatures?.filter(sig => sig.type !== "stamp") || currentUser?.signatures?.filter(sig => sig.type !== "stamp") || [];
    
    // Case 1: No signatures - show modal to create first signature
    if (!signatures || signatures.length === 0) {
      setVisibleSignatureModal(true);
      return;
    }
    
    // Case 2: Single signature - check if it's default
    if (signatures.length === 1) {
      const singleSig = signatures[0];
      if (singleSig.default_signature) {
        // Already default - auto-place immediately
        autoPlaceDefaultSignature(singleSig);
      } else {
        // Not default - show modal so user can confirm the signature first
        setVisibleSignatureModal(true);
      }
      return;
    }
    
    // Case 3: Multiple signatures - check for default
    const defaultSig = signatures.find(sig => sig.default_signature);
    if (defaultSig) {
      // Use default signature - auto-place immediately
      autoPlaceDefaultSignature(defaultSig);
    } else {
      // No default set - show modal to select
      setVisibleSignatureModal(true);
    }
  };
  
  // Auto-place default signature on all approval fields
  const autoPlaceDefaultSignature = async (signature) => {
    if (!signature || !approvalData || !currentUser) return;
    
    // Prepare signature data
    let signatureData = {};
    
    // Handle different signature types - optimized version
    const signatureSource = signature.payload_image || signature.payload;
    const signatureType = signature.type || 'signature';
    
    if (signatureSource) {
      // Check if it's already base64
      if (signatureSource.includes('data:image') || signatureSource.includes('base64')) {
        signatureData = {
          tab: signatureType,
          src: signatureSource
        };
      } 
      // Check if it's a URL path that needs conversion
      else if (signatureSource.includes('.png')) {
        try {
          const imageUrl = process.env.NODE_ENV === "development" ? "/signature.png" : `${_URL_ASSETS}${signatureSource}`;
          const base64 = await Utils.getBase64FromUrl(imageUrl);
          signatureData = {
            tab: signatureType,
            src: base64
          };
        } catch (error) {
          console.error("Error converting signature:", error);
          return;
        }
      } 
      // Try to decrypt if it's encrypted data
      else {
        try {
          const decrypted = Utils.decryptData(JSON.parse(signatureSource));
          signatureData = {
            tab: signatureType,
            src: decrypted
          };
        } catch (error) {
          console.error("Error decrypting signature:", error);
          return;
        }
      }
    }
    
    // Find all signature fields for the current user
    const currentUserData = approvalData.assignee.find(
      assignee => assignee.email === currentUser.email
    );
    
    if (currentUserData?.fields && currentUserData.fields.length > 0) {
      // Filter to only include fields with sign_status === 0 (not signed)
      const unsignedFields = currentUserData.fields.filter(field => {
        const signStatus = field.sign_status !== undefined ? Number(field.sign_status) : 0;
        return signStatus === 0;
      });
      
      if (unsignedFields.length === 0) {
        return; // No unsigned fields to sign
      }
      
      // Create signatures only for unsigned fields (sign_status === 0)
      const signatureList = unsignedFields.map(field => ({
        id: uuid(),
        pageNum: Number(field.page),
        type: "signature",
        tab: signatureData.tab || "signature",
        src: signatureData.src,
        px: Number(field.x),
        py: Number(field.y),
        pageWidth: signatureRef.current?.clientWidth || 595,
        pageHeight: signatureRef.current?.clientHeight || 842,
        width: Number(field.width),
        height: Number(field.height),
        options: signOptions,
        isApprovalField: true,
        approvalFieldId: field.id,
      }));
      
      // Get only unsigned field IDs for the current user
      const unsignedFieldIds = unsignedFields.map(field => field.id);
      
      // Replace existing approval signatures for unsigned fields only
      setSignatureImages(prev => [
        ...prev.filter(img => !img.isApprovalField || !unsignedFieldIds.includes(img.approvalFieldId)),
        ...signatureList
      ]);
      
      // Remove only unsigned placeholder fields for the current user
      setApprovalSignatureFields(prev => 
        prev.filter(field => !unsignedFieldIds.includes(field.id))
      );
      
      // Update navigationFields to mark these fields as signed (sign_status = 1)
      setNavigationFields(prev => 
        prev.map(field => 
          unsignedFieldIds.includes(field.id) 
            ? { ...field, sign_status: 1 }
            : field
        )
      );
    }
  };
  
  const cancelModal = () => {
    setVisibleSignatureModal(false);
    setVisibleStampModal(false);
    setVisibleRejectModal(false);
    setVisibleAppearanceModal(false);
    setVisibleGlobalAppearanceModal(false);
  };

  const addStamp = (_stampImage) => {
    setActiveSignature(null);
    setActiveStamp(null);
    
    addStampImage({
      id: uuid(),
      pageNum: PDFCurrentPage,
      src: _stampImage,
      type: "stamp",
      px: ((signatureRef.current?.clientWidth || 595)/2)-((signatureRef.current?.clientWidth || 595)/4),
      py: (signatureRef.current?.clientHeight || 842)/2.8,
      pageWidth: signatureRef.current?.clientWidth || 595,
      pageHeight: signatureRef.current?.clientHeight || 842,
      width: docRef?.current?.clientWidth ? docRef.current.clientWidth / 2 : 300,
    });
  };
  const saveSignature = async ({src, tab, srcArr}) => {
    let _signature = {};
    _signature.type = tab === 'signature'?'signature':'signature_image';

    // TODO Add only on type == signature
    // payload_image    
    if (tab === 'signature') {
      _signature.payload_image = src;
      _signature.payload = JSON.stringify(srcArr);
    } else{
      _signature.payload = src;
    }   
    var now = new Date();

    let _timestamp = now.getFullYear().toString(); // 2011
    _timestamp += (now.getMonth()+1).toString(); // JS months are 0-based, so +1 and pad with 0's
    _timestamp += now.getDate().toString() + ' ';
    _timestamp += now.getHours().toString() + ':';
    _timestamp += now.getMinutes().toString() + ':';
    _timestamp += now.getSeconds().toString();

    _signature.title = `Signature ${_timestamp}`;

    setSaveSignatureLoading(true);
    
    try {
      const res = await ApiServices.editProfileData({
        token: auth.token,
        data: { signature: _signature },
      });
      
      setSaveSignatureLoading(false);
      
      if (res.success === true) {
        // Refresh profile to get the new signature with ID
        await getProfileData();
        setToastMessage('Signature saved successfully!');
      } else {
        handleError(res.code, dispatch);
      }
    } catch (err) {
      console.error("===> Error response : ", err);
      setSaveSignatureLoading(false);
    }
  }
  const updateDetails = async (_signatureImage, isMultiPage, shouldSetAsDefault) => {
    const editingExistingSignature = activeSignature && activeSignature.type === "signature" && signatureImages.some(img => img.id === activeSignature.id);
    const isApprovalField = activeSignature?.isApprovalField;
    
    setActiveSignature(null);
    setActiveStamp(null);

    // Helper function to set default signature
    const handleSetDefault = async () => {
      if (!shouldSetAsDefault || !isApprovalSigning) return;
      
      const signatures = auth?.userData?.signatures?.filter(sig => sig.type !== "stamp") || currentUser?.signatures?.filter(sig => sig.type !== "stamp") || [];
      const usedSignature = signatures[signatures.length - 1];
      
      if (usedSignature?.id) {
        try {
          await ApiServices.setDefaultSignature({ token: auth.token, id: usedSignature.id });
          await getProfileData();
          setToastMessage("Signature set as default and applied successfully");
        } catch (error) {
          console.error("Error setting default signature:", error);
          setToastMessage("Signature applied successfully");
        }
      }
    };

    // Helper function to create signature objects for fields
    const createSignatureList = (fields) => {
      return fields.map(field => ({
        id: uuid(),
        pageNum: Number(field.page),
        type: "signature",
        tab: _signatureImage.tab || "signature",
        src: _signatureImage.src,
        px: Number(field.x),
        py: Number(field.y),
        pageWidth: signatureRef.current?.clientWidth || 595,
        pageHeight: signatureRef.current?.clientHeight || 842,
        width: Number(field.width),
        height: Number(field.height),
        options: signOptions,
        isApprovalField: true,
        approvalFieldId: field.id,
      }));
    };

    // Handle approval signature placement/editing
    if (isApprovalField && approvalData && currentUser) {
      await handleSetDefault();

      const currentUserData = approvalData.assignee.find(
        assignee => assignee.email === currentUser.email
      );

      if (!currentUserData?.fields?.length) return;

      // Filter to only include fields with sign_status === 0 (not signed)
      const unsignedFields = currentUserData.fields.filter(field => {
        const signStatus = field.sign_status !== undefined ? Number(field.sign_status) : 0;
        return signStatus === 0;
      });

      if (unsignedFields.length === 0) return; // No unsigned fields to sign

      // Multi-page handling
      if (isMultiPage) {
        const signatureList = createSignatureList(unsignedFields);

        if (editingExistingSignature) {
          // Replace existing approval signatures for unsigned fields only
          const unsignedFieldIds = unsignedFields.map(field => field.id);
          setSignatureImages(prev => [
            ...prev.filter(img => !img.isApprovalField || !unsignedFieldIds.includes(img.approvalFieldId)),
            ...signatureList
          ]);
        } else {
          // Add new signatures and remove placeholders for unsigned fields only
          signatureList.forEach(signature => addSignatureImage(signature));
          const unsignedFieldIds = unsignedFields.map(field => field.id);
          setApprovalSignatureFields(prev => 
            prev.filter(field => !unsignedFieldIds.includes(field.id))
          );
          
          // Update navigationFields to mark these fields as signed (sign_status = 1)
          setNavigationFields(prev => 
            prev.map(field => 
              unsignedFieldIds.includes(field.id) 
                ? { ...field, sign_status: 1 }
                : field
            )
          );
        }
      } else {
        // Single signature handling
        if (editingExistingSignature) {
          // Replace existing signature in place
          setSignatureImages(prev => 
            prev.map(img => 
              img.id === activeSignature.id
                ? { ...img, tab: _signatureImage.tab || "signature", src: _signatureImage.src, options: signOptions }
                : img
            )
          );
        } else {
          // Single signature: place on all unsigned fields for the current user
          const signatureList = createSignatureList(unsignedFields);
          
          // Add new signatures for all unsigned fields
          signatureList.forEach(signature => addSignatureImage(signature));
          
          // Remove placeholders for all unsigned fields
          const unsignedFieldIds = unsignedFields.map(field => field.id);
          setApprovalSignatureFields(prev => 
            prev.filter(field => !unsignedFieldIds.includes(field.id))
          );
          
          // Update navigationFields to mark these fields as signed (sign_status = 1)
          setNavigationFields(prev => 
            prev.map(field => 
              unsignedFieldIds.includes(field.id) 
                ? { ...field, sign_status: 1 }
                : field
            )
          );
        }
      }
      
      return; // Exit early for approval signatures
    }

    if (!!_signatureImage.url) {
      setSignatureImageUrl(_signatureImage.url);
    }
    if (!!isMultiPage) {
      setIsMultiPage(true);
      let list = [];
      for (let index = 0; index < PDFNumPages; index++) {
        list.push({
          id: uuid(),
          pageNum: index + 1,
          type: "signature",
          tab: _signatureImage.tab,
          src: _signatureImage.src,
          px: ((signatureRef.current?.clientWidth || 595)/2)-((signatureRef.current?.clientWidth || 595)/4),
          py: (signatureRef.current?.clientHeight || 842)/2.8,
          pageWidth: signatureRef.current?.clientWidth || 595,
          pageHeight: signatureRef.current?.clientHeight || 842,
          width: docRef?.current?.clientWidth ? docRef.current.clientWidth / 4 : 150,
          options:signOptions,          
        });
      }
      setSignatureImages([...list]);
    } else {
      addSignatureImage({
        id: uuid(),
        pageNum: PDFCurrentPage,
        type: "signature",
        tab: _signatureImage.tab,
        src: _signatureImage.src,
        px: ((signatureRef.current?.clientWidth || 595)/2)-((signatureRef.current?.clientWidth || 595)/4),
        py: (signatureRef.current?.clientHeight || 842)/2.8,
        pageWidth: signatureRef.current?.clientWidth || 595,
        pageHeight: signatureRef.current?.clientHeight || 842,
        width: docRef?.current?.clientWidth ? docRef.current.clientWidth / 4 : 150,
        options: signOptions,       
      });
    }
  };

  const addSignatureImage = (_img) => {
    let list = signatureImages;
    list.push(_img);
    setSignatureImages([...list]);
  };

  const editSignatureImage = (_img) => {
    let list = signatureImages;
    const found = list.find((el) => el.id === _img.id);
    if (!found) {
      list.push(_img);
    } else {
      list = list.map((el) => {
        if (el.id === found.id) {
          return _img;
        } else {
          return el;
        }
      });
    }
    setSignatureImages([...list]);
  };

  const addStampImage = (_img) => {
    let list = stampImages;
    list.push(_img);
    setStampImages([...list]);
  };

  const editStampImage = (_img) => {
    let list = stampImages;
    const found = list.find((el) => el.id === _img.id);
    if (!found) {
      list.push(_img);
    } else {
      list = list.map((el) => {
        if (el.id === found.id) {
          return _img;
        } else {
          return el;
        }
      });
    }
    setStampImages([...list]);
  };

  const clearData = () => {
    setSignatureImages([]);
    setSelectedImage(null);
    setStampImages([]);
    setSelectedStamp(null);
  };
  const getSelectedImage = () => {
    setSelectedImage(
      signatureImages.filter((img) => img.pageNum === PDFCurrentPage)
    );
  };
  const getSelectedStamp = () => {
    setSelectedStamp(
      stampImages.filter((img) => img.pageNum === PDFCurrentPage)
    );
  };

  useEffect(() => {
    setActiveSignature(null);
    setActiveStamp(null);
    setTimeout(() => {
      if (signatureRef.current) {
        signatureRef.current.style.width = docRef?.current?.clientWidth + "px";
        signatureRef.current.style.height = docRef?.current?.clientHeight + "px";
      }
    }, 300);
    return () => {};
  }, [PDFCurrentPage]);

  useEffect(() => {
    if (signatureImages.length > 0) {
      getSelectedImage();
    }else{
      setSelectedImage([])
    }
    return () => {};
  }, [signatureImages, PDFCurrentPage]);

  useEffect(() => {
    if (stampImages.length > 0) {
      getSelectedStamp();
    }else{
      setSelectedStamp([])
    }
    return () => {};
  }, [stampImages, PDFCurrentPage]);

  useEffect(() => {
    if (selectedImage) {
      // setselectedImageChanged(false);
      // setTimeout(() => {
      //   setselectedImageChanged(true);
      //   setActiveSignature(null)
      // }, 50);
      setTimeout(() => {
        handleInteract(selectedImage, isMultiPage);
        UI_OF_DELETE()
        setActiveStamp(null);
        setActiveSignature(null)
        if (signatureRef.current) {
          signatureRef.current.style.width = docRef?.current?.clientWidth + "px";
          signatureRef.current.style.height = docRef?.current?.clientHeight + "px";
        }
      }, 200);
    }
    return () => {};
  }, [selectedImage]);

  useEffect(() => {
    if (selectedStamp) {
      // setselectedStampChanged(false);
      // setTimeout(() => {
      //   setselectedStampChanged(true);
      // }, 50);
      // setTimeout(() => {
        handleStampInteract(selectedStamp);
        UI_OF_DELETE()
      // }, 200);
    }
    return () => {};
  }, [selectedStamp]);

  const handleInteract = SignatureInteract(
    signatureRef,
    editSignatureImage,
    setSignatureImages,
    PDFNumPages,
    "signature"
  );
  const handleStampInteract = SignatureInteract(
    signatureRef,
    editStampImage,
    setStampImages,
    PDFNumPages,
    "stamp"
  );
  const submitSign = () => {
    setIsSubmitting(true);
    
    // Check if this is approval signing and all fields are signed
    if (isApprovalSigning) {
      // Check if all approval signature fields have been signed
      const allFieldsSigned = !approvalSignatureFields || approvalSignatureFields.length === 0;
      
      if (!allFieldsSigned) {
        setToastMessage("Please sign all required signature fields");
        setIsSubmitting(false);
        return;
      }
    }
    
    const paramsArr = [...signatureImages.map(img=>({
      pageNum:img.pageNum,
      type:img.type,
      tab: img.tab||"",
      src:img.src,
      px:img.px,
      py:img.py,
      pageWidth:img.pageWidth,
      pageHeight:img.pageHeight,
      width:img.width,
      height:img.height,
      options: img.options,
    })), ...stampImages.map(img=>({
      pageNum:img.pageNum,
      type:img.type,
      src:img.src,
      px:img.px,
      py:img.py,
      pageWidth:img.pageWidth,
      pageHeight:img.pageHeight,
      width:img.width,
      height:img.height,
      //options: img.options,
      options: {
        displayOnBottom : false ,
        showName : false ,
        jobtitle : false ,
        showDate : false ,
        showReason: false     
      }
    }))];

    const params = {
      action: "sign", //"reject"
      reason: signComment,
      has_returnurl: !!returnURL ? true : false,
      sign_data: [...paramsArr],
    };

    ApiServices.postData({ usrToken: auth.token }, urlParams(), params)
      .then((res) => {
        if (res.success === true) {
          if (isApprovalSigning) {
            setToastMessage("Approval signed successfully");
            if (returnURL) {
              window.location.href = window.atob(returnURL);
            } else {
              setTimeout(() => {
                dispatch({ type: AUTH_STATE_UPDATE });
                clearData();
                getFileData();
              }, 2000);
            }
          }
          else {
            setToastMessage("Failed to sign document. Please try again.");
            handleError(res.code, dispatch);
          }
        }
        setIsSubmitting(false);
      })
      .catch((err) => {
        console.error("Approval signing error:", err);
        if (isApprovalSigning) {
          setToastMessage("Error signing approval");
        }
        setIsSubmitting(false);
      });
  };

  const onReject = (comment) => {
    const params = {
      action: "reject", //"reject"
      reason: comment,
      has_returnurl: !!returnURL ? true : false,
      sign_data: [],
    };
    ApiServices.postData({ usrToken: auth.token }, urlParams(), params)
      .then((res) => {
        if (res.success === true) {
          setToastMessage("Rejected Successfully");
          if (returnURL) {
            window.location.href = window.atob(returnURL);
          }
          else {
            setTimeout(() => {
              dispatch({ type: AUTH_STATE_UPDATE });
              clearData();
              getFileData();
            }, 2000);
          }
        } else {
          setToastMessage("Failed to reject document. Please try again.");
          handleError(res.code, dispatch);
        }
        setIsSubmitting(false);
      })
      .catch((err) => {
        console.log("=> Post errponse", err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      if (docRef?.current?.clientWidth && ((document.body.clientWidth - 32) / docRef.current.clientWidth) < 1) {
        setDocTransform(
          `translateY(${((document.body.clientWidth - 32) / docRef.current.clientWidth - 1)/2 * 100}%)`+` scale(${(document.body.clientWidth - 32) / docRef.current.clientWidth})`
        );
        docRef.current.classList.add('isScalled');
      }
    }, 400);
    return () => {};
  }, [docRef?.current?.clientWidth]);

  // Store original fields when they first become available (set once and never change)
  // Use navigationFields instead of approvalSignatureFields since navigationFields contains all fields
  useEffect(() => {
    if (navigationFields?.length > 0 && originalFields.length === 0) {
      const fields = JSON.parse(JSON.stringify(navigationFields));
      setOriginalFields(fields);
    }
  }, [navigationFields, originalFields.length]);

  // Toolbar handlers for signatures
  const handleDeleteSignature = (signatureId) => {
    const signature = signatureImages.find(img => img.id === signatureId);
    if (!signature) return;
    
    let list = signatureImages;
    const fieldId = signature.isApprovalField ? signature.approvalFieldId : null;
    
    // Check if there are any remaining signatures for this field BEFORE deletion
    const remainingSignatures = signatureImages.filter(img => 
      img.isApprovalField && img.approvalFieldId === fieldId && img.id !== signatureId
    );
    
    setSignatureImages([...list.filter((img) => img.id !== signatureId)]);
    
    // If this was the active signature, clear it
    if (activeSignature?.id === signatureId) {
      setActiveSignature(null);
    }
    
    // If this was an approval signature, restore the placeholder field
    if (signature.isApprovalField && fieldId) {
      // Only restore placeholder if no signatures remain for this field
      if (remainingSignatures.length === 0) {
        if (approvalData && approvalData.assignee) {
          const originalField = approvalData.assignee
            .flatMap(assignee => assignee.fields)
            .find(field => field.id === fieldId);
          if (originalField) {
            // Check if this was part of a multi-page signature
            const relatedSignatures = list.filter(img => 
              img.isApprovalField && 
              img.approvalFieldId === fieldId
            );
            
            if (relatedSignatures.length > 1) {
              // This was part of a multi-page signature, restore all related fields
              const currentUserData = approvalData.assignee.find(
                assignee => assignee.email === currentUser.email
              );
              if (currentUserData?.fields) {
                // Get all field IDs that need to be restored (no remaining signatures)
                const fieldIdsToRestore = currentUserData.fields
                  .filter(field => {
                    // Check if this field doesn't have any remaining signatures (check before deletion)
                    const hasRemainingSignature = list.some(img => 
                      img.isApprovalField && img.approvalFieldId === field.id && img.id !== signatureId
                    );
                    return !hasRemainingSignature;
                  })
                  .map(field => field.id);
                
                // Restore all signature field placeholders for the current user
                setApprovalSignatureFields(prev => {
                  const existingFields = prev.map(field => field.id);
                  const newFields = currentUserData.fields
                    .filter(field => !existingFields.includes(field.id) && fieldIdsToRestore.includes(field.id))
                    .map(field => ({
                      ...field,
                      page: Number(field.page),
                      sign_status: 0
                    }));
                  return [...prev, ...newFields];
                });
                
                // Update navigationFields to mark these fields as unsigned (sign_status = 0)
                setNavigationFields(prev => 
                  prev.map(field => 
                    fieldIdsToRestore.includes(field.id) 
                      ? { ...field, sign_status: 0 }
                      : field
                  )
                );
              }
            } else {
              // Single signature, restore just this field with sign_status === 0
              setApprovalSignatureFields(prev => [...prev, {
                ...originalField,
                page: Number(originalField.page),
                sign_status: 0
              }]);
              
              // Update navigationFields to mark this field as unsigned (sign_status = 0)
              setNavigationFields(prev => 
                prev.map(field => 
                  field.id === fieldId 
                    ? { ...field, sign_status: 0 }
                    : field
                )
              );
            }
          }
        }
      }
    }
  };

  const handleEditSignature = (signatureId) => {
    const signature = signatureImages.find(img => img.id === signatureId);
    if (!signature) return;
    
    setActiveSignature(signature);
    setIsMultiPage(false); // Reset multipage flag
    setVisibleSignatureModal(true);
  };

  const handleSignatureSettings = (signatureId) => {
    const signature = signatureImages.find(img => img.id === signatureId);
    if (!signature) return;
    
    setActiveSignature(signature);
    setVisibleAppearanceModal(true);
  };

  const handleDeleteActiveSignature = ()=>{
     if (!activeSignature) return;
     
     let list = signatureImages;
     setSignatureImages([...list.filter((img)=>img.id!==activeSignature.id)]);    
     setActiveSignature(null);
     
     // If this was an approval signature, restore the placeholder field
     if (activeSignature.isApprovalField && activeSignature.approvalFieldId) {
       // Find the original field data from approvalData
       if (approvalData && approvalData.assignee) {
         const originalField = approvalData.assignee
           .flatMap(assignee => assignee.fields)
           .find(field => field.id === activeSignature.approvalFieldId);
         if (originalField) {
           // Check if this was part of a multi-page signature
           const relatedSignatures = list.filter(img => 
             img.isApprovalField && 
             img.approvalFieldId === activeSignature.approvalFieldId
           );
           
           if (relatedSignatures.length > 1) {
             // This was part of a multi-page signature, restore all related fields
             const currentUserData = approvalData.assignee.find(
               assignee => assignee.email === currentUser.email
             );
             if (currentUserData?.fields) {
               // Restore all signature field placeholders for the current user
               setApprovalSignatureFields(prev => {
                 const existingFields = prev.map(field => field.id);
                 const newFields = currentUserData.fields
                   .filter(field => !existingFields.includes(field.id))
                   .map(field => ({
                     ...field,
                     page: Number(field.page),
                     width: Number(field.width),
                     height: Number(field.height),
                     x: Number(field.x),
                     y: Number(field.y),
                     sign_status: 0
                   }));
                 return [...prev, ...newFields];
               });
             }
           } else {
             // Single signature, just restore this one field
             // Convert the original field to numbers to match the expected format
             const convertedField = {
               ...originalField,
               page: Number(originalField.page),
               width: Number(originalField.width),
               height: Number(originalField.height),
               x: Number(originalField.x),
               y: Number(originalField.y),
               sign_status: 0
             };
             setApprovalSignatureFields(prev => [...prev, convertedField]);
           }
         }
       }
     }
   }

  const submitGlobalAppearance = (opt)=>{
    setSignOptions(opt);
  }
     const submitSignatureAppearance = (opt)=>{
     if (!activeSignature) return;
     
     let list = signatureImages;
     // if (aplyAll) {
     //   list = [...list.map((img)=>({...img, options: opt}))]
     // }else{
          const foundImg = list.find((img)=>img.id===activeSignature.id);
      if (foundImg) {
        foundImg.options = opt;
      }
     // }
     setSignatureImages([...list]);
   }

     const handleDeleteActiveStamp = ()=>{
     if (!activeStamp) return;
     
     let list = stampImages;
     setStampImages([...list.filter((img)=>img.id!==activeStamp.id)]);    
     setActiveStamp(null);    
   }

  return auth.state === STATE_DONE ? (
    isExpired ? (
      <div className="approval-expired">
      <div className="expired-card">
        <HourglassEmptyIcon className="expired-icon" />
        <h1>Approval Expired</h1>
        <p>
          The approval has expired. Please contact the approver to sign again.
        </p>
        <Alert severity="error" className="expired-alert">
          Your request can no longer be signed.
        </Alert>
      </div>
    </div>
    ) : (
    <div className="pdf-approval">
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={!!toastMessage}
        autoHideDuration={6000}
        onClose={() => {
          setToastMessage("");
        }}
      >
        <Alert
          onClose={() => {
            setToastMessage("");
          }}
          severity="success"
          sx={{ width: "100%" }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
      <FileHeader
        headRef={headRef}
        setPDFCurrentPage={setPDFCurrentPage}
        signatureImages={signatureImages}
        activeSignature={activeSignature}
        deleteSignature= {handleDeleteActiveSignature}
        activeStamp= {activeStamp}
        deleteStamp = {handleDeleteActiveStamp}
        stampImages={stampImages}
        PDFCurrentPage={PDFCurrentPage}
        PDFNumPages={PDFNumPages}
        canSign={canSign}
        canDownload={canDownload}
        file={file}
        fileTitle={fileTitle}
        setVisibleRejectModal={setVisibleRejectModal}
        t={t}
        setVisibleSignatureModal={(val) => {
          setIsMultiPage(false);
          setVisibleSignatureModal(val);
        }}
        setVisibleStampModal={setVisibleStampModal}
        setVisibleGlobalAppearanceModal={setVisibleGlobalAppearanceModal}
        setVisibleAppearanceModal={setVisibleAppearanceModal}
        isSubmitting={isSubmitting}
        submitSign={submitSign}
        canNotSignNote={canNotSignNote}
        isApprovalSigning={isApprovalSigning}
        approvalSignatureFields={approvalSignatureFields}
        navigationFields={navigationFields}
        originalFields={originalFields}
      />
      {progress < 100 && (
        <LinearProgress variant="determinate" value={progress} />
      )}
      {file && (
        <div className="pdf-doc-wrapper">
          {process.env.NODE_ENV === "development" && (
            <Alert severity="info" sx={{ mb: 2 }}>
              the display of the pdf is not working in the development environment due to cors policy so we are using a manual pdf file located in the public folder for testing
            </Alert>
          )}
          <div
            ref={docRef}
            className="docshadow"
            style={{ transform: docTransform }}
          >
            <Document
              file={process.env.NODE_ENV === "development" ? "/manual-en.pdf" : file}
              // file={file}
              onLoadSuccess={onDocumentLoadSuccess}
              options={options}
              className="pdfDoc"
              onLoadProgress={(e) => {
                setProgress((100 * e.loaded) / e.total);
                if (e < 100) {
                  return;
                } else {
                  setTimeout(() => {
                    if (signatureRef.current) {
                      signatureRef.current.style.width =
                        docRef?.current?.clientWidth + "px";
                      signatureRef.current.style.height =
                        docRef?.current?.clientHeight + "px";
                    }
                  }, 300);
                }
              }}
            >
              <Page className="pdfPage" pageNumber={PDFCurrentPage} />
            </Document>
            <div ref={signatureRef} className="signature_images">
              {
              // selectedStampChanged && 
              selectedStamp && (
                selectedStamp.map((img) => (
                  <div
                    key={img.id}
                    className="stamp-resize-drag"
                    style={{
                      width: !!img.width
                        ? img.width
                        : (docRef?.current?.clientWidth ? docRef.current.clientWidth / 4 : 150),

                      height: !!img.height ? img.height : "auto",
                      transform: `translate(${img.px}px, ${img.py}px)`,
                    }}
                    data-x={img.px}
                    data-y={img.py}
                    data-id={img.id}
                    onClick={()=>{ 
                      setActiveStamp(img)
                    }}
                  >
                    <img src={img.src} />
                    <div className="rs-hdlr rs-hdl-t"></div>
                    <div className="rs-hdlr rs-hdl-r"></div>
                    <div className="rs-hdlr rs-hdl-b"></div>
                    <div className="rs-hdlr rs-hdl-l"></div>                     
                  </div>
                ))
              )}
              {
              // selectedImageChanged && 
              selectedImage && (
                  selectedImage.map((img) => (
                    <div
                      key={img.id}
                                             className={`signature-resize-drag ${img.options?.displayOnBottom?'options-bottom':''}`}
                      style={{
                        width: !!img.width ? img.width : (docRef?.current?.clientWidth ? docRef.current.clientWidth / 4 : 150),
                        height: !!img.height ? img.height : "auto",
                        transform: `translate(${img.px}px, ${img.py}px)`,
                      }}
                      data-x={img.px}
                      data-y={img.py}
                      data-id={img.id}
                      onClick={()=>{ 
                        setActiveSignature(img)
                      }}
                    >
                      <SignatureToolbar
                        onDelete={() => handleDeleteSignature(img.id)}
                        onEdit={() => handleEditSignature(img.id)}
                        onSettings={() => handleSignatureSettings(img.id)}
                        isApprovalField={img.isApprovalField}
                      />
                      <img src={img.src} alt="signature" />
                      <div className="rs-hdlr rs-hdl-t"></div>
                      <div className="rs-hdlr rs-hdl-r"></div>
                      <div className="rs-hdlr rs-hdl-b"></div>
                      <div className="rs-hdlr rs-hdl-l"></div>
                      { (img.options?.showName||img.options?.jobtitle||img.options?.showDate||img.options?.showReason) && 
                        (<div className="info-wrapper" style={{
                          width: img.width<180? 
                                180: 
                                (img.width>(docRef?.current?.clientWidth/3)?(docRef?.current?.clientWidth/3 || 200):img.width)
                        }}>
                          {img.options?.showName && auth?.userData?.name && <span className="name">{auth.userData.name}</span>}
                          {img.options?.jobtitle && auth?.userData?.title && <span className="title">{auth.userData.title}</span>}
                          {img.options?.showDate && <span className="date"><Moment date={moment()} format="YYYY/MM/DD hh:m"/></span>}
                          {img.options?.showReason && signComment && <p className="reason">{signComment}</p>}
                        </div>)
                      }
                    </div>                    
                  ))               
              )}
              {/* Approval Signature Placeholders - Only show fields with sign_status === 0 */}
              {isApprovalSigning && canSign && approvalSignatureFields && approvalSignatureFields
                .filter((field) => field.page === PDFCurrentPage && field.sign_status === 0)
                .map((field, index) => (
                  <div
                    key={`approval-${field.id}-${index}`}
                    className="approval-signature-placeholder"
                    style={{
                      position: "absolute",
                      left: `${field.x}px`,
                      top: `${field.y}px`,
                      width: `${field.width}px`,
                      height: `${field.height}px`,
                      background: "rgba(255, 255, 0,1)",
                      border: "2px dashed #ff9800",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      zIndex: 10,
                    }}
                    onClick={() => {
                      // Store the field info
                      setActiveSignature({ ...field, isApprovalField: true });
                      handleApprovalSignClick();
                    }}
                  >
                    <span style={{ color: "#000", fontSize: "12px", fontWeight: "600", textAlign: "center" }}>
                      ✒️ Click to Sign
                    </span>
                  </div>
                ))}
              
              {/* Signature Field Indicators (Fixed position on the left side) - Show all fields except rejected (sign_status === 2) */}
              {navigationFields && navigationFields.length > 0 && (
                  navigationFields
                    .filter(field => {
                      const signStatus = field.sign_status !== undefined ? Number(field.sign_status) : 0;
                      return field.page === PDFCurrentPage && signStatus !== 2; // Don't show rejected fields
                    })
                    .map((field, index) => {
                      const signStatus = field.sign_status !== undefined ? Number(field.sign_status) : 0;
                      const isPending = signStatus === 0;
                      const isSigned = signStatus === 1;
                      return (
                        <div
                          key={`indicator-${field.id}-${index}`}
                          className={`signature-indicator ${isSigned ? 'signed' : isPending ? 'pending' : ''}`}
                          style={{
                            position: 'absolute',
                            left: '-50px', // Fixed position before the page starts
                            top: `${field.y}px`, // Use the same Y coordinate as signature placeholders
                            width: '60px',
                            height: '40px',
                            zIndex: 20
                          }}
                        >
                          <div className="indicator-label">
                            {field.type === 'signature' ? 'SIGN' : 'INITIAL'}
                          </div>
                        </div>
                      );
                    })
              )}
            </div>
          </div>
        </div>
      )}
      {visibleSignatureModal && (
        <PDFModalSignature
          visible={visibleSignatureModal}
          cancel={cancelModal}
          updateDetails={updateDetails}
          saveSignature = {saveSignature}
          comment = {signComment}
          setComment = {setSignComment}
          isApprovalSigning={isApprovalSigning}
          refreshProfile={getProfileData}
        />
      )}
      {visibleStampModal && (
        <PDFModalStamp
          visible={visibleStampModal}
          cancel={cancelModal}
          addStamp={addStamp}
        />
      )}

      {visibleGlobalAppearanceModal && (
        <AppearanceModal
          visible={visibleGlobalAppearanceModal}
          cancel={cancelModal}
          onSubmit={submitGlobalAppearance}
          appearanceOptions={signOptions}
        />
      )}
      {visibleAppearanceModal && (
        <AppearanceModal
          visible={visibleAppearanceModal}
          cancel={cancelModal}
          onSubmit={submitSignatureAppearance}
          activeSignature={activeSignature}
        />
      )}
      {visibleRejectModal && (
        <RejectModal
          visible={visibleRejectModal}
          cancel={cancelModal}
          onReject={onReject}
        />
      )}
    </div>
    )
  ) : (
    <>
      <CircularProgress
        color="inherit"
        style={{
          width: "18px",
          height: "18px",
          marginInlineEnd: "6px",
        }}
      />
    </>
  );
};

export default PDFApproval;

function SignatureInteract(
  signatureRef,
  editSignatureImage,
  setSignatureImages,
  _PDFNumPages,
  _selector
) {
  return (_img, isMultiPage) => {
    const position = { x: _img.px, y: _img.py };
    const widgets = document.querySelectorAll("." + _selector + "-resize-drag");

    if (widgets.length === 0) return; // No widgets to make interactive

    interact("." + _selector + "-resize-drag")
      .resizable({
        // resize from all edges and corners
        // margin: ((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth) < 1?36:16,
        margin: 36,
        // edges: { 
        //   left  : '.rs-hdl-l', 
        //   right : '.rs-hdl-r', 
        //   bottom: '.rs-hdl-b', 
        //   top   : '.rs-hdl-t' 
        // },
        edges: { 
          left  : ['.rs-hdl-l', '.rs-hdl-t', '.rs-hdl-l',], 
          right : ['.rs-hdl-r','.rs-hdl-b', '.rs-hdl-r'], 
          // bottom: '.rs-hdl-b', 
          // top   : '.rs-hdl-t' 
        },        
        // edges: { 
        //   left  : true, 
        //   right : true, 
        //   bottom: true, 
        //   top   : true 
        // },
        
        listeners: {
          start(event) {
            event.target.setAttribute("selected", true);
          },
          move(event) {
            var target = event.target;
            position.x = parseFloat(target.getAttribute("data-x")) || 0;
            position.y = parseFloat(target.getAttribute("data-y")) || 0;

            // update the element's style
            if (((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth) < 1) {
              target.style.width = parseInt(event.rect.width / ((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth)) + "px";
              target.style.height = parseInt(event.rect.height / ((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth)) + "px";              
            } else {
              target.style.width = parseInt(event.rect.width) + "px";
              target.style.height = parseInt(event.rect.height) + "px";
            }
            
            // translate when resizing from top or left edges
            position.x += event.deltaRect.left;
            position.y += event.deltaRect.top;
            target.style.transform = "translate(" + position.x + "px," + position.y + "px)";
            target.setAttribute("data-x", position.x);
            target.setAttribute("data-y", position.y);
          },
          end(event) {
            widgets.forEach((el) => {
              const elID = el.dataset.id;
              if (!el.getAttribute("selected")) {
                return;
              }
              const { x: dataX = "0", y: dataY = "0" } = el.dataset;
              const x = (parseFloat(dataX) || 0) + event.delta.x;
              const y = (parseFloat(dataY) || 0) + event.delta.y;
              let _image = {};
              if (((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth) < 1) {
                _image = {
                  ..._img.find(img=>elID === img.id),
                  px: x,
                  py: y,
                  width: parseInt(event.rect.width / ((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth)),
                  height: parseInt(event.rect.height / ((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth)),
                  pageWidth: signatureRef?.current?.clientWidth,
                  pageHeight: signatureRef?.current?.clientHeight,
                }
              }else{
                _image = {
                  ..._img.find(img=>elID === img.id),
                  px: x,
                  py: y,
                  width: parseInt(event.rect.width),
                  height: parseInt(event.rect.height),
                  pageWidth: signatureRef?.current?.clientWidth,
                  pageHeight: signatureRef?.current?.clientHeight,
                }
              }
  
              if (isMultiPage) {
                const list = [];
                for (let index = 0; index < _PDFNumPages; index++) {
                  list.push({ ..._image, ...{ pageNum: index + 1 } });
                }
                setSignatureImages([...list]);
              } else {
                editSignatureImage(_image);
              }
            }) 
            event.target.removeAttribute("selected");
          },
        },
        
        modifiers: [
          // keep the edges inside the parent
          interact.modifiers.restrictEdges({
            outer: "parent",
          }),
          // interact.modifiers.restrictRect({
          //   restriction: 'parent',
          //   endOnly: true
          // }),
          // minimum size
          interact.modifiers.restrictSize({
            min: { width: 20, height: 10 },
          }),
          interact.modifiers.aspectRatio({
            // make sure the width is always double the height
            // ratio: 2,
            // also restrict the size by nesting another modifier
            modifiers: [interact.modifiers.restrictSize({ max: "parent" })],
          }),
        ],

        inertia: true,
      })
      .draggable({
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent',
            endOnly: true
          })
        ],
        inertia: true,
        listeners: {
          start(event) {
            event.target.setAttribute("selected", true);
          },
          move(event) {
            widgets.forEach((el) => {
              if (!el.getAttribute("selected")) {
                return;
              }
              const { x: dataX = "0", y: dataY = "0" } = el.dataset;

              const x = (parseFloat(dataX) || 0) + event.delta.x;
              const y = (parseFloat(dataY) || 0) + event.delta.y;

              el.style.transform = `translate(${x}px, ${y}px)`;
              Object.assign(el.dataset, { x, y });
            });
          },
          end(event) {
            widgets.forEach((el) => {
              const elID = el.dataset.id;
              if (!el.getAttribute("selected")) {
                return;
              }
              const { x: dataX = "0", y: dataY = "0" } = el.dataset;
              const x = (parseFloat(dataX) || 0) + event.delta.x;
              const y = (parseFloat(dataY) || 0) + event.delta.y;

              const _image =
              (document.body.clientWidth - 32) / signatureRef?.current?.clientWidth < 1 ? 
                {
                    ..._img.find(img=>img.id === elID),
                    px: x,
                    py: y,
                    width: parseInt( event.rect.width / ((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth) ),
                    height: parseInt( event.rect.height / ((document.body.clientWidth - 32) / signatureRef?.current?.clientWidth) ),
                    pageWidth: signatureRef?.current?.clientWidth,
                    pageHeight: signatureRef?.current?.clientHeight,
                }
                : 
                {
                    ..._img.find(img=>img.id === elID),
                    px: x,
                    py: y,
                    width: parseInt(event.rect.width),
                    height: parseInt(event.rect.height),
                    pageWidth: signatureRef?.current?.clientWidth,
                    pageHeight: signatureRef?.current?.clientHeight,
                };

              if (isMultiPage) {
                const list = [];
                for (let index = 0; index < _PDFNumPages; index++) {
                  list.push({ ..._image, ...{ pageNum: index + 1 } });
                }
                setSignatureImages([...list]);
              } else {
                editSignatureImage(_image);
              }
            });    
            event.target.removeAttribute("selected");
          },
        },
      });

    if (widgets.length > 0) {
      widgets.forEach((el) => {
        // if (Utils.is_touch_enabled()) {
        //   el.addEventListener("touchstart", (e) => {
        //     widgets.forEach((_el) => {
        //       _el.removeAttribute("selected")
        //     });
        //     setTimeout(() => {
        //       el.setAttribute("selected", true);
        //     }, 200);
        //   });
        // }else{
          el.addEventListener("mousedown", (e) => {
            widgets.forEach((_el) => {
              _el.removeAttribute("selected")
            });
            setTimeout(() => {
              el.setAttribute("selected", true);
            }, 200);
          });
        // }
      });      
    }

    if (document.querySelector(".signature_images")) {
      // if (Utils.is_touch_enabled()) {
      //   document.querySelector(".signature_images").addEventListener("touchstart", () => {
      //     widgets.forEach((el) => {
      //       el.removeAttribute("selected")
      //     });
      //   });
      // }else{
        document.querySelector(".signature_images").addEventListener("mousedown", () => {
          widgets.forEach((el) => {
            el.removeAttribute("selected")
          });
        });
      // }
    }
  };
}
